module.exports = __webpack_public_path__ + "media/flags/gb-c29f2b77.svg";